import { render, staticRenderFns } from "./AfterLoanCollateralEdit.vue?vue&type=template&id=bcd5c3d8&"
import script from "./AfterLoanCollateralEdit.vue?vue&type=script&lang=js&"
export * from "./AfterLoanCollateralEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports